var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"css-h81dkj"},[_c('div',{staticClass:"line-wrapper"},[_c('div',{staticClass:"circle"},[_c('i',{staticClass:"shipment-history-icon material-icons warning",class:{
						warning: _vm.history && !_vm.history.isPlaceholder && !_vm.isDelivered,
						danger:
							_vm.history &&
							!_vm.history.isPlaceholder &&
							_vm.dangerStatuses.includes(_vm.history.status),
						active: _vm.history && !_vm.history.isPlaceholder && _vm.isDelivered,
					}},[_vm._v(_vm._s(_vm.icon))])]),_c('div',{staticClass:"line"})]),_c('div',{staticClass:"status-wrapper"},[_c('div',{staticClass:"status",domProps:{"innerHTML":_vm._s(this.sanitizeHtml(_vm.tooltip))}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }